<template>
<svg class="logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 444 137.5">
  <g>
    <path class="cls-5" d="m136.33,79.54c-4.59,0-7.68,3.53-7.68,8.78s3.09,8.74,7.68,8.74c3.28,0,5.81-1.75,7.03-4.65h4.81c-1.41,5.72-5.81,9.34-11.81,9.34-7.31,0-12.18-5.4-12.18-13.43s4.87-13.43,12.18-13.43c6,0,10.34,3.59,11.81,9.34h-4.84c-1.25-2.9-3.75-4.69-7-4.69Z"/>
    <path class="cls-5" d="m176.05,95.85c-1.28,3.5-4.59,5.9-8.4,5.9-5.43,0-9.25-3.97-9.25-9.59s3.94-9.56,9.15-9.56,9.18,4.12,9.18,9.49c0,.56-.03,1.12-.13,1.65h-13.59c.56,2.31,2.31,3.81,4.59,3.81,1.72,0,3.06-.69,3.72-1.72h4.72Zm-3.94-5.31c-.56-2.25-2.28-3.72-4.56-3.72s-3.97,1.47-4.5,3.72h9.06Z"/>
    <path class="cls-5" d="m193.48,98.97c-.75,1.62-3.19,2.81-5.59,2.81-5.47,0-8.93-3.81-8.93-9.59s3.47-9.56,8.93-9.56c2.4,0,4.81,1.16,5.59,2.84v-2.62h4.44v18.74h-4.44v-2.62Zm-5.03-1.66c3,0,5.06-2.06,5.03-5.09,0-3-2.09-5.15-5.03-5.15s-5.03,2.03-5.03,5.12,2,5.12,5.03,5.12Z"/>
    <path class="cls-5" d="m209.99,87.07c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m233.69,79.48v6.62h11.21v4.44h-11.21v6.59h11.78v4.47h-16.24v-26.55h15.96v4.44h-11.49Z"/>
    <path class="cls-5" d="m257.02,87.07c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m285.75,95.85c-1.28,3.5-4.59,5.9-8.4,5.9-5.43,0-9.25-3.97-9.25-9.59s3.94-9.56,9.15-9.56,9.18,4.12,9.18,9.49c0,.56-.03,1.12-.13,1.65h-13.59c.56,2.31,2.31,3.81,4.59,3.81,1.72,0,3.06-.69,3.72-1.72h4.72Zm-3.94-5.31c-.56-2.25-2.28-3.72-4.56-3.72s-3.97,1.47-4.5,3.72h9.06Z"/>
    <path class="cls-5" d="m300.25,87.07c-4.25,0-6.59,2-6.59,5.65v8.87h-4.44v-18.74h4.44v3.12c1.34-2.31,3.97-3.34,6.59-3.34v4.44Z"/>
    <path class="cls-5" d="m316.26,98.97c-.75,1.62-3.15,2.81-5.53,2.81-5.4,0-8.93-3.81-8.93-9.59s3.53-9.56,8.93-9.56c2.37,0,4.78,1.19,5.53,2.84v-2.62h4.47v17.74c0,5.78-3.62,9.59-9.06,9.59-4.62,0-8-2.72-8.9-7.15h4.69c.75,1.75,2.31,2.72,4.22,2.72,2.75,0,4.59-2.03,4.59-5.15v-1.62Zm-4.97-1.66c2.94,0,5-2.06,4.97-5.09,0-2.97-2.09-5.15-4.97-5.15s-5.03,2.03-5.03,5.12,2.06,5.12,5.03,5.12Z"/>
    <path class="cls-5" d="m333.59,103.44c-1.53,3.94-2.12,5.78-6.59,5.78h-1.41v-4.4h1c1.16,0,1.84-.28,2.44-1.78l.53-1.44-7.06-18.74h4.75l4.69,12.46,4.68-12.46h4.75l-7.78,20.58Z"/>
    <path class="cls-5" d="m350.98,101.6v-26.55h15.96v4.44h-11.49v6.62h11.21v4.44h-11.21v11.06h-4.47Z"/>
    <path class="cls-5" d="m377.45,97.35c2.31,0,4-2.15,4-5.12v-9.37h4.47v18.74h-4.47v-2.62c-.66,1.65-2.65,2.84-4.78,2.84-4.78,0-7.75-3.81-7.75-9.56v-9.4h4.44v9.4c0,3.09,1.62,5.09,4.09,5.09Z"/>
    <path class="cls-5" d="m397.75,87.07c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m423.53,98.97c-.75,1.62-3.15,2.81-5.59,2.81-5.47,0-8.93-3.81-8.93-9.59s3.47-9.56,8.93-9.56c2.41,0,4.81,1.16,5.59,2.84v-10.43h4.47v26.55h-4.47v-2.62Zm-5.03-1.66c3,0,5.06-2.06,5.03-5.09,0-3-2.09-5.15-5.03-5.15s-5.03,2.03-5.03,5.12,2.03,5.12,5.03,5.12Z"/>
  </g>
  <g>
    <path class="cls-5" d="m136.33,39.49c-4.59,0-7.68,3.53-7.68,8.78s3.09,8.75,7.68,8.75c3.28,0,5.81-1.75,7.03-4.65h4.81c-1.41,5.72-5.81,9.34-11.81,9.34-7.31,0-12.18-5.4-12.18-13.43s4.87-13.43,12.18-13.43c6,0,10.34,3.59,11.81,9.34h-4.84c-1.25-2.9-3.75-4.68-7-4.68Z"/>
    <path class="cls-5" d="m161.93,47.02c-4.25,0-6.59,2-6.59,5.65v8.87h-4.44v-18.74h4.44v3.12c1.34-2.31,3.97-3.34,6.59-3.34v4.44Z"/>
    <path class="cls-5" d="m172.62,42.59c5.22,0,9.21,4.15,9.21,9.56s-4,9.59-9.21,9.59-9.28-4.15-9.28-9.59,4.06-9.56,9.28-9.56Zm-4.81,9.56c0,2.94,2.09,5.12,4.81,5.12s4.78-2.19,4.78-5.12-2.06-5.12-4.78-5.12-4.81,2.22-4.81,5.12Z"/>
    <path class="cls-5" d="m193.02,47.02c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m206.08,47.02h-2.59v-4.22h2.59v-1.47c0-4.72,1.97-6.56,6.62-6.56h1.56v4.4h-1.16c-1.75,0-2.59.75-2.59,2.41v1.22h3.75v4.22h-3.75v14.52h-4.44v-14.52Z"/>
    <path class="cls-5" d="m230.47,58.92c-.75,1.62-3.19,2.81-5.59,2.81-5.47,0-8.93-3.81-8.93-9.59s3.47-9.56,8.93-9.56c2.4,0,4.81,1.16,5.59,2.84v-2.62h4.44v18.74h-4.44v-2.62Zm-5.03-1.66c3,0,5.06-2.06,5.03-5.09,0-3-2.09-5.15-5.03-5.15s-5.03,2.03-5.03,5.12,2,5.12,5.03,5.12Z"/>
    <path class="cls-5" d="m258.51,61.55h-4.44v-11.27l-9.18-15.27h5.12l6.28,11.28,6.28-11.28h5.12l-9.18,15.27v11.27Z"/>
    <path class="cls-5" d="m275.75,47.02c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m296.05,47.02c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
    <path class="cls-5" d="m333.7,46.15h14.24c.09.75.16,1.47.16,2.15,0,8.03-5.62,13.4-12.59,13.4s-12.56-5.4-12.56-13.43,5.25-13.43,12.49-13.43c5.56,0,9.71,2.87,11.59,7.59h-4.81c-1.31-1.97-3.81-3.12-6.75-3.12-4.62,0-8.06,3.37-8.06,8.96s3.37,8.96,8.12,8.96c4.06,0,7.18-2.53,7.93-6.87h-9.78v-4.22Z"/>
    <path class="cls-5" d="m373.01,58.92c-.75,1.62-3.19,2.81-5.59,2.81-5.47,0-8.93-3.81-8.93-9.59s3.47-9.56,8.93-9.56c2.4,0,4.81,1.16,5.59,2.84v-2.62h4.44v18.74h-4.44v-2.62Zm2.25-17.74h-4.81l-2.19-2.94-2.22,2.94h-4.81l4.59-6.18h4.84l4.59,6.18Zm-7.28,16.09c3,0,5.06-2.06,5.03-5.09,0-3-2.09-5.15-5.03-5.15s-5.03,2.03-5.03,5.12,2,5.12,5.03,5.12Z"/>
    <path class="cls-5" d="m389.51,47.02c-2.34,0-4.03,2.19-4.03,5.15v9.37h-4.44v-18.74h4.44v2.62c.69-1.66,2.69-2.84,4.81-2.84,4.78,0,7.75,3.81,7.75,9.56v9.4h-4.47v-9.4c0-3.09-1.59-5.12-4.06-5.12Z"/>
  </g>
  <g>
    <path class="cls-5" d="m308.06,37.38c0-1.55.95-2.56,2.48-2.56s2.49,1.01,2.49,2.56-.99,2.58-2.49,2.58-2.48-1.03-2.48-2.58Z"/>
    <polygon class="cls-5" points="308.37 46.11 312.76 42.81 312.76 61.73 308.37 61.73 308.37 46.11"/>
  </g>
  <g>
    <polygon class="cls-5" points="155.56 74.87 155.56 101.78 151 101.78 151 78.13 155.56 74.87"/>
    <polygon class="cls-5" points="356.08 34.82 356.08 61.73 351.52 61.73 351.52 38.08 356.08 34.82"/>
  </g>

  <g>
    <path class="cls-2" d="m61.37,117.2c-8.05-.51-15.57-2.99-22.08-6.95.54-.2,1.12-.45,1.73-.72,1.22-.56,2.29-1.12,3.26-1.63,3.13-1.64,5-2.62,7.85-.08,2.87,2.57,4.98,3.58,7.43,3.32.6-.06,1.2-.21,1.8-.43v6.48h0Zm-26.79-10.2c-4.81-3.76-8.89-8.41-12-13.7.98.1,1.81.44,2.39,1.08,2.78,3.07,4.83,4.72,7.19,5.26,2.41.55,4.78-.12,8.19-1.68,1.22-.56,2.29-1.12,3.26-1.63,3.13-1.64,5-2.62,7.85-.08,2.87,2.57,4.98,3.58,7.43,3.32.82-.09,1.62-.32,2.46-.69v7.46c-.87.49-1.59.77-2.22.84-1.16.12-2.42-.58-4.37-2.32-4.91-4.38-7.68-2.93-12.33-.48-.92.48-1.93,1.01-3.08,1.54-2.24,1.03-3.65,1.37-4.78,1.08h0Zm-14.02-17.5c-1.11-2.34-2.04-4.79-2.77-7.32,2.76-.77,5.23-.87,6.53.56,2.78,3.07,4.83,4.72,7.19,5.26,2.41.55,4.78-.12,8.19-1.68,1.22-.56,2.29-1.12,3.26-1.63,3.13-1.64,5-2.62,7.85-.08,2.87,2.57,4.98,3.58,7.43,3.32,1.03-.11,2.03-.45,3.11-.99v7.46c-1.17.72-2.09,1.14-2.88,1.23-1.16.12-2.42-.58-4.37-2.32-4.91-4.38-7.68-2.93-12.33-.48-.92.48-1.93,1.01-3.08,1.54-2.61,1.19-4.3,1.73-5.67,1.42-1.42-.32-2.91-1.6-5.12-4.04-1.82-2.01-4.46-2.52-7.35-2.23h0Zm-3.69-11.08c-.44-2.15-.73-4.34-.87-6.58h34.66c1.2,5.24,5.3,9.37,10.52,10.62-1.39.89-2.45,1.42-3.34,1.52-1.16.12-2.42-.58-4.37-2.32-4.91-4.38-7.68-2.93-12.33-.48-.92.48-1.93,1.01-3.08,1.54-2.61,1.19-4.3,1.73-5.67,1.42-1.42-.32-2.91-1.6-5.12-4.04-2.44-2.7-6.38-2.7-10.39-1.66h0Z"/>
    <path class="cls-1" d="m113,71.83c-.37,5.79-1.75,11.3-3.97,16.37-2.85-6.18-12.06-4.29-12.71,1.18,8.51-4.01,13.53,8.54-13.34,10.27,10.13.55,16.57-.42,20.58-2.02-8.27,11.15-21.2,18.63-35.92,19.57v-34.7c5.31-1.2,9.49-5.36,10.71-10.66h34.66Zm-33.87,11.87c9.63-17.23,31.82,15.8-10.01,11.19,22.42-.62,19.69-15.75,10.01-11.19h0Zm-1.5,21.67c.39,3.31,6.08,4.41,7.63.46.89-2.25-.04-7.38-15.53-6.54,15.91,1.03,12.94,8.46,7.9,6.08h0Z"/>
    <path class="cls-3" d="m50.64,65.57H16c.39-6.14,1.92-11.96,4.38-17.27l20.11,9.28,11.12,5.13c-.42.91-.75,1.87-.97,2.87h0Zm-25.81-24.94c3.2-4.51,7.14-8.46,11.66-11.65l12.76,18.07,7.06,10c-1.32.93-2.47,2.09-3.41,3.41l-10-7.06-18.07-12.76h0Zm19.33-16.08c4.92-2.27,10.28-3.74,15.92-4.25l2.02,22.02,1.12,12.19c-1.65.15-3.22.58-4.66,1.24l-5.13-11.12-9.27-20.09h0Z"/>
  </g>
  <path class="cls-4" d="m98.79,57.19l-35.94,12.39c-1.14.39-2.03-1.03-1.17-1.88l17.23-16.99-9.31-7.43c-1.22-.97-1.15-2.84.13-3.72l24.6-17.02c.84-.58,1.97-.54,2.76.09l12.79,10.2c1.32,1.05,1.11,3.12-.39,3.88l-18.71,9.52,8.71,6.95c1.43,1.14,1.04,3.41-.69,4.01Z"/>
</svg>
</template>

<script>
export default {
	name: 'BGFLogo'
};
</script>

<style scoped>
.cls-1 {
  fill: #00c584;
  fill-rule: evenodd;
  stroke-width: 0;
}
.cls-2 {
  fill: #00667e;
  fill-rule: evenodd;
  stroke-width: 0;
}

.cls-1 {
    fill: #00c584;
  }

  .cls-1, .cls-2, .cls-3 {
    fill-rule: evenodd;
  }

  .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {
    stroke-width: 0px;
  }

  .cls-2 {
    fill: #dadada;
  }

  .cls-3 {
    fill: #c7e600;
  }

  .cls-4 {
    fill: #98d900;
  }

  .cls-5 {
    fill: #fff;
  }

.logo {
  width: 40rem;
  height: auto;
  display: block;
}

@media screen and (max-width: 1024px) {
  .logo {
    width: 30rem;
  }
}

@media screen and (max-width: 550px) {    
  .logo {
    width: 24rem;
  }

}

.st1{fill:#5cc234}
.st2{fill:#f79c31}
.st3{fill:#fff}
</style>
